import {Controller} from "stimulus"

export default class extends Controller {
    static targets = ["checkboxContainer", "allCheckboxContainer"]

    connect() {
    }

    toggleRow(event) {
        // Wird direkt auf die Checkbox geklickt, dann macht der Checkbox-Standard-Mechanismus seinen Job.
        if (event.target.type === "checkbox") return

        const checkbox = event.currentTarget.querySelector('input[type="checkbox"]')
        if (checkbox) {
            checkbox.click();
        }
    }

    toggleAllCheckboxes(event) {
        console.log('toggle all', this.checkboxContainerTarget.checked);

        this.checkboxContainerTargets.forEach((checkbox) => {
            if (checkbox == this.allCheckboxContainerTarget) {
                console.log('toggle allsdfsdfds',);

            } else {
                checkbox.checked = this.checkboxContainerTarget.checked

            }

        })
        return false;
    }

}
